import { Button, Tag, Tooltip, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { StatusBadge } from '@/shared/ui/StatusBadge';
import type { RiskCard } from '@/entities/risk/model/riskSchema';
import type { Status } from '@/entities/user/model/userSchema';
import { riskLevelColors } from './constants';
import { isOverdue } from './utils';

const { Text } = Typography;

export function getRiskCardColumns(openEdit: (record: RiskCard) => void): ColumnsType<RiskCard> {
  return [
    {
      title: 'Рабочее место',
      dataIndex: 'workplace',
      key: 'wp',
      render: (text: string) => <span style={{ color: 'var(--o500)', fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'Опасность',
      dataIndex: 'hazard',
      key: 'hazard',
      render: (text: string, r: RiskCard) => (
        <Tooltip title={r.justification ? `Обоснование: ${r.justification}` : undefined}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    { title: 'В', dataIndex: 'probability', key: 'prob', width: 40 },
    { title: 'Т', dataIndex: 'severity', key: 'sev', width: 40 },
    {
      title: 'Уровень',
      key: 'level',
      render: (_: unknown, r: RiskCard) => (
        <Tag color={riskLevelColors[r.level]}>
          {r.level} ({r.riskScore})
        </Tag>
      ),
    },
    {
      title: 'Пересмотр',
      dataIndex: 'reviewDate',
      key: 'review',
      width: 100,
      render: (d: string | undefined) => {
        if (!d) return <Text type="secondary">—</Text>;
        const overdue = isOverdue(d);
        return <span style={overdue ? { color: '#cf1322', fontWeight: 600 } : undefined}>{d}</span>;
      },
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (st: Status) => (
        <StatusBadge status={st} label={st === 'ok' ? 'Утверждена' : st === 'info' ? 'Согласование' : 'Черновик'} />
      ),
    },
    {
      title: 'Действия',
      key: 'actions',
      width: 80,
      render: (_: unknown, r: RiskCard) => (
        <Button
          type="link"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            openEdit(r);
          }}
        >
          Изменить
        </Button>
      ),
    },
  ];
}
